import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import AutoBalanceTransferTransactionInfo from './AutoBalanceTransferTransactionInfo';
import useFetchEFTWithdrawTransaction from '@/hooks/useApi/useFetchEFTWithdrawTransaction';
import useFetchACHWithdrawTransaction from '@/hooks/useApi/useFetchACHWithdrawTransaction';
import useFetchAutoBalanceTransferReport from '@/hooks/useApi/useFetchAutoBalanceTransferReport';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

type EftWithdrawTransactionProps = {
  transactionID: string;
  transactionHeader?: vp.TransactionsLists;
};

type FC = FunctionComponent<EftWithdrawTransactionProps>;

const AutoBalanceTransferTransactionContainer: FC = (props: EftWithdrawTransactionProps) => {
  const { userSettings } = useUserSettingsProvider();
  const { transactionID, transactionHeader } = props;
  const [eftWithdrawTransaction, getEftWithdrawTransaction] = useFetchEFTWithdrawTransaction({ bearer: '' });
  const [achWithdrawTransaction, getAchWithdrawTransaction] = useFetchACHWithdrawTransaction({ bearer: '' });
  const [autoBalanceTransferReport, getAutoBalanceTransferReport] = useFetchAutoBalanceTransferReport({});
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] =
    useState<vp.EftWithdrawTransactionResponse | vp.ACHWithdrawTransactionResponse>();

  useEffect(() => {
    if (transactionHeader?.TransactionType === vp.TransactionType.EFT_WITHDRAWAL) {
      getEftWithdrawTransaction({ TransactionID: transactionID, Timezone: userSettings.timezone });
    } else if (transactionHeader?.TransactionType === vp.TransactionType.ACH_WITHDRAWAL) {
      getAchWithdrawTransaction({ TransactionID: transactionID, Timezone: userSettings.timezone });
    }
    getAutoBalanceTransferReport(transactionID);
  }, [currentTransactionId, transactionID]);

  useEffect(() => {
    if (eftWithdrawTransaction) {
      setTransaction(eftWithdrawTransaction);
    }
  }, [eftWithdrawTransaction]);

  useEffect(() => {
    if (achWithdrawTransaction) {
      setTransaction(achWithdrawTransaction);
    }
  }, [achWithdrawTransaction]);

  if (currentTransactionId !== transactionID) {
    setCurrentTransactionId(transactionID);
  }

  return (
    <div>
      {transaction && transactionHeader && autoBalanceTransferReport && (
        <AutoBalanceTransferTransactionInfo
          transaction={transaction}
          autoBalanceTransferReport={autoBalanceTransferReport}
          transactionHeader={transactionHeader}
        />
      )}
    </div>
  );
};

export default AutoBalanceTransferTransactionContainer;
